const SvgTags = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="icon">
        <path
          id="Vector"
          d="M10.5 1.5C9.90327 1.5 9.33121 1.73717 8.90921 2.15918L2.15921 8.90918C1.28547 9.78291 1.28547 11.2171 2.15921 12.0908L5.9092 15.8408C6.33121 16.2628 6.90327 16.5 7.50003 16.5C8.09678 16.5 8.66884 16.2628 9.09085 15.8408L15.8408 9.09082C16.263 8.66866 16.5 8.09602 16.5 7.49927V3.375C16.5 2.3462 15.6538 1.5 14.625 1.5H10.5ZM10.5 2.625H14.625C15.0437 2.625 15.375 2.9563 15.375 3.375V7.49927C15.375 7.80401 15.2608 8.08007 15.0454 8.29541L8.29544 15.0454C8.07994 15.2609 7.80477 15.375 7.50003 15.375C7.19528 15.375 6.92011 15.2609 6.70462 15.0454L2.95462 11.2954C2.5121 10.8529 2.5121 10.1471 2.95462 9.70459L9.70462 2.95459C9.92011 2.7391 10.1953 2.625 10.5 2.625ZM12.75 4.125C12.1287 4.125 11.625 4.62862 11.625 5.25C11.625 5.87138 12.1287 6.375 12.75 6.375C13.3714 6.375 13.875 5.87138 13.875 5.25C13.875 4.62862 13.3714 4.125 12.75 4.125Z"
          className="fill-current"
        />
      </g>
    </svg>
  );
};

export default SvgTags;
